/* -------------------------------------------

	Name:		Moment In Line
	Date:		2021/11/11

---------------------------------------------  */
/*global jQuery, document, window, yall, setTimeout */
var i = 0,
	img_lazy = document.querySelectorAll('img[data-src]:not(.dont)');
for (i = 0; i < img_lazy.length; i = i + 1) {
	img_lazy[i].classList.add('lazy');
}
document.addEventListener('DOMContentLoaded', function () {
	'use strict';
	yall({
		observeChanges: true,
		threshold: 500
	});
});
jQuery(function () {
	"use strict";
	var
		$ = jQuery.noConflict(),
		html_tag = document.documentElement,

		footer_id = document.getElementById('footer'),
		footer_date = footer_id ? footer_id.querySelectorAll('.date') : [],
    input_amount = $(document.getElementsByClassName('input-amount')),
    
    list_product = $(document.getElementsByClassName('list-product')),

		email_tag = document.getElementsByClassName('email'),

		Default = {
			utils: {
				mails: function () {
					if (email_tag.length) {
						Array.from(email_tag).filter(function (el) {
							return el.tagName.toLowerCase() !== 'input' && el.tagName.toLowerCase() !== 'div';
						}).forEach(function (el) {
							el.innerText = el.innerText.replace('//', '@').replace(/\//g, '.');
							if (el.tagName.toLowerCase() === 'a') {
								el.setAttribute('href', 'mailto:' + el.innerText);
							}
						});
					}
				},
				date: function () {
					if (footer_date.length) {
						footer_date[0].innerText = (new Date()).getFullYear();
					}
				},
				mobile: function () {
					if (window.mobileCheck()) {
						html_tag.classList.add('mobile');
					} else {
						html_tag.classList.add('no-mobile');
					}
				},
				done: function () {
					var tag = document.createElement('script');
					tag.src = scripts_async_url;
					document.body.appendChild(tag);
				},
				miscellaneous: function () {
          if (input_amount.length) {
						input_amount.find('input[type="number"]').semanticNumber();
					}

					if (list_product.length) {
						list_product.each(function () {
							if ($(this).children().length > 1) {
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: false,
									dots: false,
                  rtl: true,
                  items: 1,
									lazyLoad: true,
									margin: 30,
									center: true,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
				}
			}

		};
	setTimeout(function () {
		Default.utils.mails();
		Default.utils.date();
		Default.utils.miscellaneous();
		Default.utils.mobile();
		Default.utils.done();
	}, 0);
});

/*!*/
